<template>
    <teleport to="head">
        <meta name="title" content="Brandon Aguirre | Software Engineer"/>
        <meta name="description" content="Software engineer & computer science enthusiast with a passion for building interactive web applications, machine learning, and working with all kinds of data."/>
        <link rel="canonical" href="https://brandonaguirre.com">
    </teleport>
    <div id="home_page_top">
        <suspense>
            <template #default>
                <sketch-background @scroll-flip="scrollAndFlip()"/>
            </template>
            <template #fallback>
                <div id="welcome">
                    <h1>Welcome.</h1>
                    <h1>Welcome.</h1>
                    <h1>Welcome.</h1>
                </div>
            </template>
        </suspense>
    </div>
    <div id="home_page_bottom">
        <about-section ref="about"/>
    </div>
</template>

<script>
    import { defineAsyncComponent } from 'vue'

    const SketchBackground = defineAsyncComponent(() => {
        const component = import('@/components/SketchBackground')
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(component)
            }, 1500);
        })
    })

    import AboutSection from './HomePage/AboutSection'
    import zenscroll from 'zenscroll'
    import debounce from '@/helpers/debounce'

    export default {
        name: "HomePage",
        components: {
            AboutSection,
            SketchBackground
        },
        data () {
            return {
                autoscrolling: false,
                scrollTime: 2500
            }
        },
        computed: {
            
        },
        methods: {
            scrollDown (elId, minus = 0) {
                this.autoscrolling = true
                let about = document.getElementById(elId ? elId : "home_page_bottom")
                zenscroll.toY(about.offsetTop - minus, this.scrollTime, () => this.autoscrolling = false)
            },
            scrollUp () {
                this.autoscrolling = true
                let top = document.getElementById("home_page_top")
                zenscroll.toY(top.offsetTop - 50, this.scrollTime, () => { this.autoscrolling = false })
            },
            scrollListenHandler () {
                if (this.autoscrolling) return

                let about = document.getElementById("home_page_bottom")
                let top = document.getElementById("home_page_top")
                if (this.$route.hash !== '#about' && window.scrollY > about.offsetTop - 300) {
                    this.$router.replace({ hash: '#about', params: { noscroll: true} })
                } else if (this.$route.hash === '#about' && window.scrollY <= about.offsetTop - 300) {
                    this.$router.replace({ hash: null, params: { noscroll: true } })
                }
            },
            scrollBasedOnHash (hash) {
                if (hash === '#about') {
                    this.scrollDown()
                } else {
                    this.scrollUp()
                }
            },
            scrollAndFlip () {
                this.$refs.about.flip(false)
                this.scrollDown('business_card_section', 200)
                setTimeout(() => {
                    this.$refs.about.flip(true)
                }, this.scrollTime - 200);
            }
        },
        watch: {
            $route(to, from) {
                if (to.name !== 'Home' || to.params.noscroll === 'true') return zenscroll.stop()
                this.scrollBasedOnHash(to.hash)
            }
        },
        mounted () {
            this._debouncedScrollListenHandler = debounce(this.scrollListenHandler, 50)
            window.addEventListener('scroll', this._debouncedScrollListenHandler)
            if (this.$route.hash === '#about') this.scrollBasedOnHash('#about')
        },
        unmounted () {
            window.removeEventListener('scroll', this._debouncedScrollListenHandler)
        }
    }
</script>

<style scoped lang="scss">
    $text-color: black;

    #welcome {
        color: black;
        text-align: center;
        font-family: Inter,Source Sans Pro,Helvetica Neue,Arial,sans-serif;
        font-size: 6vh;
        width: 100%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -40%);
    }

    #home_page_top {
        position: relative;
        height: calc(100vh - 50px);
        color: $text-color;
        color: white;
        overflow: hidden;
    }

    #home_page_bottom {
        min-height: calc(100vh - 50px);
        padding: 0 10px 50px 10px;
    }

</style>